const twittertext = require('twitter-text');

module.exports = function() {
    let Twitter = {};

    Twitter.maxLength = 280;

    Twitter.replaceMergeTags = function(message, link) {
      let campaignTagUrl = '[@campaign]';

      if (message.includes(campaignTagUrl)) {
        message = message.replace(this.tagMatchingRegexString(), link);
      } else {
        message = `${message} ${link}`;
      }
      return message;
    };

    Twitter.tagMatchingRegexString = function() {
      return /\[@campaign]/g;
    };

    Twitter.legMatchingRegexString = function() {
      return /\[@TwitterHandle]/g;
    };

    Twitter.advocateMatchingRegexString = function() {
      return /\[@advFirst]/g;
    };

    Twitter.handleRegexString = function() {
      return /\@[\w*]{1,15}/gi;
    }

    Twitter.countRemainingCharacters = function (message, includesCampaignLink) {
      let parsed = twittertext.parseTweet(message);
      const arrows = message.match(/➡/g);

      if (arrows && arrows.length) {
        parsed.weightedLength = parsed.weightedLength + (arrows.length * 2);
      }

      let remainingCharacters = this.maxLength - parsed.weightedLength;

      // Look for all [@campaign] tags in the message
      let tagRegex = message.match(this.tagMatchingRegexString());
      if (tagRegex && tagRegex.length > 0) {
        tagRegex.forEach((tag) => {
          remainingCharacters += tag.length;
          if (message.indexOf('[@campaign]') > 0) {
            // No longer need the space before the URL
            remainingCharacters += 1;
          }
          remainingCharacters -= 24;
        });
      }

      // Look for all [@TwitterHandle] tags in the message
      let legRegex = message.match(this.legMatchingRegexString());
      if (legRegex && legRegex.length > 0) {
        legRegex.forEach((tag) => {
          /**
          * Adjust the length of the tweet to account for username
          * format: " .@username" in the case [@TwitterHandle] is at the start of the tweet
          * ==> 17 = 15 (Twitter Maximum Length for a username) + @ + .
          *     17 - "[@TwitterHandle]".length = 1
          */
          remainingCharacters -= 1;
          if(message.indexOf('[@TwitterHandle]') === 0) {
            remainingCharacters -= 0;
          }
        });
      };

      return remainingCharacters;
    };

    Twitter.containsMergeVar = function(text) {
      return text.match(this.legMatchingRegexString()) ||
             text.match(this.tagMatchingRegexString()) ||
             text.match(this.advocateMatchingRegexString());
    };

    return Twitter;
};
